
export interface HttpResponse {
    success:                    boolean;
    message:                    string;
}

export interface VersionResponse extends HttpResponse {
    version:                    string;
}

export const defaultVersionResponse: VersionResponse = {
    success:                    false,
    message:                    '',
    version:                    ''
}

export interface LoginParams {
    correoElectronico:          string;
    contrasena:                 string;
}

export interface LoginResponse extends HttpResponse {    
    nombres?:                   string;
    apellidos?:                 string;
    token?:                     string;
    correoElectronico?:         string;
    autoridad?:                 string;
    administrador?:             boolean;
    restablecerContrasena?:     boolean;
}